import React from 'react'

export const About = () => (
    <div>
          <h2>About Page</h2>  
          <p>This is the First Iteration Demo site of Soroka's Multi-Agents Operating Rooms Management (ORM) system.
              For the Demo, Agents have a simple GUI for logging-in, viewing patients and operations, and decisions making.
          </p>
    </div>
)
